import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export function resolveTranslation(title: string): string {
  const translateService = inject(TranslateService);
  return translateService.instant(title);
}
